import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Accordion, AccordionItem } from 'react-sanfona';
import './App.css';

class App extends Component {
  render() {
      const games = {
          "favorites": [
              "Super Mario 64",
              "Street Fighter II Turbo",
              "The Legend of Zelda: A Link to The Past",
              "Spelunky HD",
              "Portal",
              "Portal 2",
              "Sam n Max Hit the Road",
              "Full Throttle",
              "NyxQuest",
              "Contra",
              "Leisure Suit Larry",
              "Mega Man X4",
              "Vandal Hearts",
              "Quake III",
              "Bruce Lee",
              "Sonic The Hedgehog 2",
              "Bionic Commando",
              "New Super Mario Bros Wii",
              "Super Mario World",
              "Gunstar Heroes",
              "Tekken 3",
              "Mortal Kombat 3",
              "Soul Blade/Edge",
              "The Lost Vikings",
              "Mike Tyson's Punchout!",
              "Donkey Kong Country",
              "Crash Bandicoot (series)",
              "Mega Man X",
              "Turtles in Time",
              "Double Dragon NES",
              "Super Mario RPG",
              "Earthworm Jim",
              "Secret of Mana",
              "The Legend of Zelda",
              "F-Zero",
              "TMNT Arcade Game",
              "Killer Instinct",
              "Killer Instinct 2",
              "Kights of the Round",
              "Punisher",
              "Final Fight",
              "New Super Mario Bros DS",
              "Defender of the Crown",
              "Flashback",
              "Gauntlet Legends",
              "7th Guest",
              "Lemmings",
              "Excitebike",
              "Kyrandia",
              "Kyrandia II: Hand of Fate",
              "Donkey Kong Country 2",
              "Unreal Tournament 2004",
              "Gauntlet Dark Legacy",
              "Monkey Island (series)",
              "Duke Nukem 3D",
              "Yoshi's Island DS",
              "The Magical Quest starring Mickey Mouse",
              "X-men 2: Clone Wars",
              "Super Mario World 2: Yoshi's island",
              "Super Mario Bros. 2",
              "Super Mario Bros. 3",
              "Metal Slug (series)",
              "Warcraft II",
              "King's Quest VI",
              "Tetris",
              "Virtua Tennis"
          ],
          "beaten": {
              "NES": [
                  "Bionic Commando",
                  "Super Mario Bros. 2",
                  "Super Mario Bros. 3",
                  "Contra",
                  "TMNT II: The Arcade Game",
                  "The Legend of Zelda",
                  "Super Mario Bros.",
                  "Double Dragon",
                  "Gun.Smoke",
              ],
              "SNES": [
                  "Super Mario World",
                  "TMNT IV: Turtles in Time",
                  "Harley's Humungous Adventure",
                  "Pitfall: The Mayan Adventure",
                  "Earthworm Jim",
                  "Earthworm Jim 2",
                  "The Magical Quest Staring Mickey Mouse",
                  "Mega Man X",
                  "Donkey Kong Country",
                  "Super Mario World 2: Yoshi's Island",
                  "The Legend of Zelda: A Link to the Past",
                  "Super Mario RPG",
                  "Donkey Kong Country 2",
              ],
              "Genesis": [
                  "Sonic The Hedgehog 2",
                  "Golden Axe",
                  "Aladdin",
                  "Gunstar Heroes",
                  "Taz Mania",
              ],
              "Nintendo 64": [
                  "Super Mario 64",
                  "Gauntlet Legends",
              ],
              "Wii": [
                  "Super Mario Galaxy",
                  "New Super Mario Bros Wii",
                  "Super Mario Galaxy 2",
              ],
              "DS": [
                  "New Super Mario Bros DS",
                  "Yoshi's Island DS",
              ],
              "3DS": [
                  "Donkey Kong Country Returns",
                  "Gunman Clive",
                  "The Legend of Zelda: A Link Between Worlds",
                  "Fantasy Life",
              ],
              "Playstation": [
                  "Crash Bandicoot",
                  "Vandal Hearts",
                  "Croc",
                  "Mega Man X4",
                  "Crash Bandicoot 2: Cortex Strikes Back",
              ],
              "Playstation 2": [
                  "Gauntlet Seven Sorrows",
              ],
              "Playstation 3": [
                  "Portal 2",
                  "Rocket Knight Adventures",
                  "Bionic Commando Rearmed",
                  "Pac-Man Championship Ed. DX",
                  "Vandal Hearts: Flames of Judgement",
                  "The Cave",
                  "DuckTales Remastered",
                  "Bit.Trip Runner 2",
                  "Castle Crashers",
                  "Spelunky HD",
                  "Dungeons & Dragons: Shadow over Mystara",
              ],
              "Playstation Vita": [
                  "Limbo",
              ],
              "PC": [
                  "Bruce Lee (C64)",
                  "Space Ace (Amiga)",
                  "Defender of the Crown (Amiga)",
                  "RoboCop (Amiga)",
                  "7th Guest (DOS)",
                  "Quake III (Windows)",
                  "Portal (Windows)",
                  "Trine (Windows)",
                  "NyxQuest (iPad)",
                  "Bit.Trip Runner (Windows)",
              ],
              "Arcade": [
                  "Teenage Mutant Ninja Turtles",
                  "Final Fight",
                  "Knights of the Round",
                  "X-men",
                  "The Punisher",
                  "Metal Slug",
                  "Metal Slug 2",
                  "Bad Dudes",
                  "Cow Boys of Moo Mesa",
                  "Crime Fighters",
                  "Metal Slug X",
                  "Metal Slug 3",
              ],
              "Adventure": [
                  "Leisure Suit Larry",
                  "Sam n Max Hit The Road",
                  "Full Throttle",
                  "Legend of Kyrandia",
                  "Legend of Kyrandia 2",
                  "Freddy Pharkas Frontier Pharmacist",
                  "Secret of Monkey Island: SE",
              ],
              "Fighting": [
                  "Street Fighter II",
                  "Street Fighter II Turbo",
                  "Super Street Fighter II",
                  "Super Street Fighter II Turbo",
                  "Samuri Shodown II",
                  "Mortal Kombat",
                  "Mortal Kombat 2",
                  "Mortal Kombat 3",
                  "Ultimate Mortal Kombat 3",
                  "Mortal Kombat 4",
                  "Killer Instinct",
                  "Killer Instinct 2",
                  "Soul Edge / Blade",
                  "Tekken 3",
                  "Tekken 5",
                  "Street Fighter III: Third Strike",
                  "Street Fighter IV",
                  "Mortal Kombat 9",
              ]
          }
      };

      const total_beaten = Object.keys(games["beaten"]).reduce((acc, item) =>
          acc + games["beaten"][item].length, 0);

      return <div className="App">
          <header className="App-header">
              <h1 className="App-title">GamesFTW</h1>
          </header>
          <p className="App-intro">
              Stuff about games by <a href="http://www.brentwoodruff.com">Brent W. Woodruff</a>
          </p>
          <Grid fluid>
              <Row>
                  <Col xs={12} md={6}>
                      <h2>Games Beaten ({total_beaten})</h2>
                          <Accordion allowMultiple="true">
                              {Object.keys(games["beaten"]).map(item => {
                                  return (
                                      <AccordionItem title={`${item + ' (' + games["beaten"][item].length + ')'}`}>
                                          <div className="game-list-container">
                                              <div className="game-list">
                                                  <ol>
                                                      {games["beaten"][`${item}`].map(game => {
                                                          return (
                                                              <li>{game}</li>
                                                          )
                                                      })}
                                                  </ol>
                                              </div>
                                          </div>
                                      </AccordionItem>
                                  )
                              })}
                      </Accordion>
                  </Col>
                  <Col xs={12} md={6}>
                      <h2>Favorite Games ({games["favorites"].length})</h2>
                      <Accordion>
                          <AccordionItem title={"Roughly in order"} expanded="true">
                              <div className="game-list-container">
                                  <div className="game-list">
                                      <ol>
                                          {games["favorites"].map((game, index) => {
                                              return (
                                                  <div>
                                                      {index + 1}. {game}
                                                  </div>
                                              )
                                          })}
                                      </ol>
                                  </div>
                              </div>
                          </AccordionItem>
                      </Accordion>
                  </Col>
              </Row>
          </Grid>
      </div>;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js